<template>
  <transition name="fade">
    <div class="modal-backdrop">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import '@/scss/modalBackdrop.scss'

export default {
  name: 'BaseBackdrop'
}
</script>
